import Vue from 'vue';
import Vuetify from 'vuetify';
// @ts-ignore
import VueVirtualScroller from 'vue-virtual-scroller';
import VueI18n from 'vue-i18n';
import { en } from '@/assets/locales/en';
import { de } from '@/assets/locales/de';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@/assets/global.css';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    de
  }
});

console.log(de);

Vue.config.productionTip = false;
Vue.use(Vuetify);

Vue.use(VueVirtualScroller);
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
